/* eslint-disable no-underscore-dangle */
import { ButtonFragment } from '@src/generated/graphql';

export default (button: Maybe<ButtonFragment>): string => {
  if (!button) return '';

  if (button.linkType === 'External') {
    return button.externalLink ?? '';
  }

  if (button.linkType === 'Internal') {
    const { link } = button;

    if (link?.__typename === 'Homepage') return '/';
    if (link?.__typename === 'MainBlogPage') return '/blog';

    return `/${link?.slug?.current ?? ''}`;
  }

  return '';
};
